export const TODAY_RESERVATION_DEADLINE = 1800;
